import * as THREE from 'three';
import { jsondan } from '../FikoThreeType';
import { FikoImporter } from './FikoImporter';
import { FikoObje3D } from './FikoObje3D';
import { FikoSahne } from './FikoSahne';
import { FikoCizimDXF } from './FikoThreeCam/FikoCizimDXF';
import { FikoCizimFBX } from './FikoThreeCam/FikoCizimFBX';
import { FikoCizimGLB } from './FikoThreeCam/FikoCizimGLB';
import { FikoCizimSTL } from './FikoThreeCam/FikoCizimSTL';
import { FikoCizimWRL } from './FikoThreeCam/FikoCizimWRL';

declare var $: any;

export class FikoGrupCizim extends FikoObje3D {
    static SAYAC = 1;

    override type = 'FikoGrupCizim';
    readonly isGroup: true;

    public get liste(): any[] {
        return this.children;
    }

    sagButonlar?: any[] = [
        {
            baslik: "Stl Dosyası Ekle",
            simge: "folder open outline",
            tiklandi: () => {
                this.ekleDosyadan();
            }
        },
    ];


    sagMenu: any[] = [
        {
            simgeYazi: "👁‍🗨",
            baslik: "Gizle / Göster",
            tiklandi: () => {
                this.visible = !this.visible;
                this.sahne.anaGosterim.FikoYT.degisti.emit();
                // this.sahne.anaGosterim.ciz();
            }
        },
        {
            tipi: "Ayraç"
        },
        {
            baslik: "FikoWrl Dosyası Ekle",
            simge: "folder open outline",
            tiklandi: () => {
                this.ekleDosyadan();
            }
        },
        {
            simgeYazi: "🗑",
            baslik: "Sil",
            tiklandi: () => {
                while (this.children.length) {
                    this.remove(this.children[0]);
                }

                this.parent.remove(this);

                this.sahne.anaGosterim.FikoYT.degisti.emit();
                // this.sahne.anaGosterim.ciz();
            }
        }
    ]

    aracCubugu: any[] = [
        {
            baslik: "FikoWrl Dosyası Ekle",
            simge: "folder open outline",
            tiklandi: () => {
                this.ekleDosyadan();
            }
        },
        {
            simge: "trash alternate",
            baslik: "Sil",
            renkSinif: "red",
            tiklandi: () => {
                let _this = this;
                $('body')
                    .toast({
                        message: `Bu Grup Ve Tüm Alt Nesneler Silinecektir, Onaylıyormusunuz?`,
                        displayTime: 3000,
                        class: 'black',
                        classActions: 'top attached',
                        actions: [{
                            text: 'Evet Onaylıyorum',
                            class: 'red',
                            click: function () {
                                while (_this.children.length) {
                                    _this.remove(_this.children[0]);
                                }

                                _this.parent.remove(_this);
                                _this.sahne.anaGosterim.aktifItem = null;
                                _this.sahne.anaGosterim.FikoYT.degisti.emit();
                                // _this.sahne.anaGosterim.ciz();
                            }
                        }, {
                            text: 'Hayır',
                            class: 'green',
                            click: function () {

                            }
                        }]
                    });
            }
        }
    ]

    constructor(public override sahne?: FikoSahne, isim?: string) {
        super(sahne);
        this.name = isim;

        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = true;
        this.userData['FikoArayuz'].simge = "./simgeler/kupler.webp";

        if (!isim) {
            this.name = "FikoGrupÇizim." + FikoGrupCizim.SAYAC;
            FikoGrupCizim.SAYAC++;
        } else {
            this.name = isim;
        }

    }

    override ekle?(...objeler: THREE.Object3D[]): FikoGrupCizim {
        super.add(...objeler);

        return this;
    }

    ekleGrup(isim?: string) {
        let grpCizim = new FikoGrupCizim(this.sahne, isim);
        this.ekle(grpCizim)
        return grpCizim;
    }

    async ekleDosyadan(filter?: string) {
        const importer = new FikoImporter(this);

        // Progress callback - ana gosterim'deki yuklemeDurumu'nu güncelle
        if (this.sahne?.anaGosterim) {
            const anaGosterim = this.sahne.anaGosterim;

            importer.onProgress = (mesaj: string, progress: number) => {
                // State güncelle
                anaGosterim.yuklemeDurumu.aktif = true;
                anaGosterim.yuklemeDurumu.mesaj = mesaj;
                anaGosterim.yuklemeDurumu.progress = progress;

                // Change detection'ı tetikle - Zone içinde çalıştır
                setTimeout(() => {
                    try {
                        anaGosterim.CD.detectChanges();
                    } catch (e) {
                    }
                }, 0);

                // Yükleme tamamlandığında kapat
                if (progress >= 100) {
                    setTimeout(() => {
                        anaGosterim.yuklemeDurumu.aktif = false;
                        try {
                            anaGosterim.CD.detectChanges();
                        } catch (e) {
                        }
                    }, 1000);
                }
            };

        } else {
        }

        importer.dosyadan(".wrl, .FikoWrl");

        return null;
        return new Promise((resolve, reject) => {

            const _this = this;
            let input = document.createElement("input");
            input.type = "file";
            input.onchange = ($event: any) => {
                // console.log($event.target.files[0])
                if ($event.target.files && $event.target.files[0]) {
                    const dosya: File = $event.target.files[0]

                    if (dosya.name.indexOf(".stl") > -1) {
                        const stlFile = new FikoCizimSTL(this.sahne);
                        stlFile.dosyadan(dosya);
                        stlFile.name = dosya.name + ".FikoStl"
                        _this.ekle(stlFile);
                        resolve(stlFile)
                    }

                    if (dosya.name.indexOf(".dxf") > -1) {
                        const stlFile = new FikoCizimDXF(this.sahne);
                        stlFile.dosyadan(dosya);
                        stlFile.name = dosya.name + ".FikoDxf"
                        resolve(stlFile)
                        _this.ekle(stlFile);
                    }

                    if (dosya.name.indexOf(".wrl") > -1 || dosya.name.indexOf(".FikoWrl") > -1) {
                        const stlFile = new FikoCizimWRL(this.sahne);
                        stlFile.dosyadan(dosya);
                        stlFile.name = dosya.name.replace(".wrl", "").replace(".FikoWrl", "")
                        resolve(stlFile)
                        _this.ekle(stlFile);
                    }

                    if (dosya.name.indexOf(".fbx") > -1) {
                        const stlFile = new FikoCizimFBX(this.sahne);
                        stlFile.dosyadan(dosya);
                        stlFile.name = dosya.name + "." + ".FikoFBX"
                        resolve(stlFile)
                        _this.ekle(stlFile);
                    }

                    if (dosya.name.indexOf(".glb") > -1) {
                        const gltfFile = new FikoCizimGLB(this.sahne);
                        gltfFile.dosyadan(dosya);
                        gltfFile.name = dosya.name + "." + ".FikoGLB"
                        resolve(gltfFile)
                        _this.ekle(gltfFile);
                    }

                }
            }
            input.click();

        })
    }

    override toJSON(meta?: { geometries: any; materials: any; textures: any; images: any }): any {
        const _rslt: any = { type: this.type, isim: this.name, uuid: this.uuid };//< g super.toJSON(meta);

        const childs: any[] = []

        for (let index = 0; index < this.children.length; index++) {
            const element: any = this.children[index];
            // Sadece FikoGL sınıflarını serialize et (raw Three.js Mesh/Line vs. atla)
            if (element.type && element.type.startsWith('Fiko')) {
                childs.push(element.toJSON());
            }
        }

        _rslt.children = childs;

        _rslt.userData = this._serializeUserData();
        _rslt.visible = this.visible;
        _rslt.matrix = this.matrix.toArray();

        return _rslt;
    }

    static fromJson(sahne?: FikoSahne, parent?: any, json?: any, binBuffers?: Uint8Array[]) {
        const _rslt = new FikoGrupCizim(sahne, json.isim);
        _rslt.uuid = json.uuid;
        _rslt.parent = parent;

        for (let i = 0; i < json.children.length; i++) {
            let element = json.children[i];
            const child = jsondan(sahne, _rslt, element, binBuffers);
            if (child) _rslt.ekle(child);
        }

        if (json.userData) _rslt._restoreUserData(json.userData);
        if (json.visible !== undefined) _rslt.visible = json.visible;
        if (json.matrix) {
            _rslt.matrix.fromArray(json.matrix);
            _rslt.matrix.decompose(_rslt.position, _rslt.quaternion, _rslt.scale);
        }

        return _rslt;
    }

    toStr() {
        let _rslt = `{ "uuid":"${this.uuid}","ismi": "${this.name}","type":"${this.type}",`;
        _rslt += `"children":[`;
        let ilk = true;
        for (let i = 0; i < this.liste.length; i++) {
            const element = this.liste[i];
            // Sadece FikoGL sınıflarını ve toStr destekleyenleri serialize et
            if (!element.type || !element.type.startsWith('Fiko') || !element.toStr) continue;
            if (!ilk) _rslt += `,`;
            _rslt += element.toStr();
            ilk = false;
        }
        _rslt += `]`;
        _rslt += `}`;

        return _rslt;
    }
}